import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Popover } from 'antd';
import { QuestionCircleTwoTone } from '@ant-design/icons';
import { connect } from 'react-redux';
import {
  CartesianGrid,
  ComposedChart,
  Label,
  Legend,
  Line,
  ReferenceDot,
  Tooltip,
  XAxis,
  YAxis,
  ReferenceLine
} from 'recharts';
import WidgetActionComponent from '../../../../components/WidgetActionComponent';
import Card from '../../components/Card';
import Wait4Me from '../../../../components/Wait4Me';
import {
  getCRSClusterInformationData,
  getCRSTrendAnalysisData
} from '../../../../redux/actions/crs/crsRiskDetail';
import {
  getDataFromResponse,
  getDecimalInPercentage,
  getDecimalToHundredScale,
  getDecimalWithoutHundredMultiplier,
  getFormattedDate,
  getInDecimal
} from '../../../../services/util';
import {
  dateFormat_DD_MM_YY,
  dateTimeFormat
} from '../../../../util/GlobalConstant';
import {
  CRS_CONSTANTS,
  CRS_CLUSTER_RISK_INDICATOR_TAB
} from '../../../constants/crsContants';
import { ClusterInformation } from '../ClusterInformation';
import { processDataFromProps } from '../riskDetailUtil';
import style from './index.scss';
import ClusterRiskIndicators from '../ClusterRiskIndicators';

const { GET_DATA } = CRS_CONSTANTS;

const renderTooltip = (props, ruleBased) => {
  const { payload = [] } = props || {};
  return (
    <div
      style={{
        padding: 10,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        background: 'white',
        width: 180,
        height: 100,
        border: '1px solid #D9D9D9',
        borderRadius: 5
      }}>
      {Array.isArray(payload) &&
        payload.map((entry, index) => {
          const { payload: innerPayload = { rawRoundedCustomerRiskScore } } =
            entry || {};
          const { clusterId = '' } = innerPayload || {};
          if (entry.dataKey === 'customerRiskScore') {
            return (
              <div
                style={{ display: 'flex', flexDirection: 'column' }}
                key={`item-${index}`}>
                <div
                  style={{
                    fontStyle: 'normal',
                    fontWeight: 'normal',
                    fontSize: 12,
                    color: '#99A6B5',
                    paddingBottom: '5px'
                  }}>
                  {/* Cluster ID: {clusterId + '_' + getInDecimal(entry.value)} */}
                  {/* Cluster ID: {clusterId} */}
                  <strong>Cluster</strong>
                </div>
                {!ruleBased && (
                  <div
                    style={{
                      fontStyle: 'normal',
                      fontWeight: 'normal',
                      fontSize: 12,
                      color: '#99A6B5'
                    }}>
                    {/* Alert Yield: {`${getInDecimal(entry.value)}%`} */}
                    Alert Yield:{' '}
                    {`${getInDecimal(innerPayload.clusterMeanScore)}%`}
                  </div>
                )}
                <div
                  style={{
                    fontStyle: 'normal',
                    fontWeight: 'normal',
                    fontSize: 12,
                    color: '#99A6B5'
                  }}>
                  Risk Score: {innerPayload.rawRoundedCustomerRiskScore}
                </div>
              </div>
            );
          }

          // if (entry.dataKey === 'clusterMeanScore') {
          //   return (
          //     <div
          //       style={{
          //         fontFamily: 'Rubik',
          //         fontStyle: 'normal',
          //         fontWeight: 'normal',
          //         fontSize: 12,
          //         color: '#99A6B5'
          //       }}
          //       key={`item-${index}`}>
          //       Alert Yield: {`${getInDecimal(entry.value)}%`}
          //     </div>
          //   );
          // }
        })}
      {/* <div style={{ fontSize: 9, alignSelf: 'center', marginTop: 10 }}>
        Click dot for cluster details.
      </div> */}
    </div>
  );
};

const COLORS = {
  RED: '#E84D42',
  ORANGE: '#EB9229',
  GREEN: '#48C93D',
  BLACK: '#000',
  WHITE: '#fff'
};

const RANGES = {
  NONE: 0,
  LOW: 20,
  MID: 50,
  HIGH: 80
};

const { RED, ORANGE, GREEN, BLACK, WHITE } = COLORS;
const { LOW, MID, HIGH, NONE } = RANGES;

const DEFAULT_CURRENT_PAGE = 1;
const DEFAULT_PAGE_SIZE = 15;
const DEFAULT_ACTIVE_TAB = CRS_CLUSTER_RISK_INDICATOR_TAB[0];

const renderLegend = (props, ruleBased) => {
  const { payload } = props;
  return (
    <div className={style.legendContainer}>
      {payload.map((entry, index) => (
        <div key={index} className={style.legendTitle}>
          <span
            className={`${style.legendLabel} ${
              entry.dataKey === 'customerRiskScore'
                ? style.customerRiskScore
                : style.customerMeanScore
            }`}></span>
          {entry.value}
        </div>
      ))}

      {!ruleBased && (
        <Popover
          placement="top"
          content={
            <div style={{ padding: 10 }}>
              <span>
                Average of risk scores of all customers in the cluster to which
                the customer belongs to.
              </span>
            </div>
          }>
          <span className={style.popoverIcon}>
            <QuestionCircleTwoTone />
          </span>
        </Popover>
      )}
    </div>
  );
};

class TrendAnalysisComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDefaultClusterFetched: false,
      point1: {
        x: 0,
        y: 0
      },
      point2: {
        x: 0,
        y: 0
      },
      latestCluster: {},
      dateRange: {
        startDate: moment().subtract(30, 'days').add(1, 'days'),
        endDate: moment(),
        activeRangeNo: 2
      },
      activeTabKey: '1',
      currentPage: DEFAULT_CURRENT_PAGE,
      currentPageSize: DEFAULT_PAGE_SIZE,
      clusterIndicatorGroup: DEFAULT_ACTIVE_TAB
    };
  }

  componentDidMount() {
    this.fetchCTAData();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps?.crsRiskDetailData) {
      const { crsRiskDetailData = {} } = nextProps;
      const { trendAnalysisData } = processDataFromProps(crsRiskDetailData);
      const { data = {}, fetched } = trendAnalysisData || {};
      const { customerScores = [] } = data || {};
      const {
        isDefaultClusterFetched,
        clusterIndicatorGroup,
        currentPage,
        currentPageSize
      } = this.state;
      if (fetched && !isDefaultClusterFetched && customerScores.length > 0) {
        this.setState({ isDefaultClusterFetched: true });
        const customerScoreLength = customerScores.length;
        const latestCluster = customerScores[customerScoreLength - 1];
        let {
          customerRiskScore = 0.0,
          clusterMeanScore = 0,
          date
        } = latestCluster;
        const formattedCluster = {
          ...latestCluster,
          // customerRiskScore: getDecimalToHundredScale(customerRiskScore),
          // clusterMeanScore: getDecimalInPercentage(clusterMeanScore)
          customerRiskScore: parseFloat(customerRiskScore).toFixedNoRounding(2),
          clusterMeanScore: `${parseFloat(clusterMeanScore).toFixedNoRounding(
            2
          )} %`
        };
        this.setState({
          latestCluster: formattedCluster,
          point1: {
            x: getFormattedDate(date, dateFormat_DD_MM_YY),
            y: getDecimalToHundredScale(clusterMeanScore)
          },
          point2: {
            x: getFormattedDate(date, dateFormat_DD_MM_YY),
            y: formattedCluster.customerRiskScore
          }
        });
        this.props.dispatch(
          getCRSClusterInformationData(
            {
              clusterId: latestCluster.clusterId,
              modelId: latestCluster.modelId,
              clusterIndicatorGroup,
              limit: currentPageSize,
              offset: (currentPage - 1) * currentPageSize
            },
            GET_DATA
          )
        );
      }
    }
  }

  onDatePickerSelection = (dateRange) => {
    this.setState(
      {
        ...this.state,
        isDefaultClusterFetched: false,
        activeTabKey: `1`,
        clusterIndicatorGroup: DEFAULT_ACTIVE_TAB,
        dateRange: {
          startDate: dateRange.from,
          endDate: dateRange.to
        }
      },
      () => {
        this.fetchCTAData();
      }
    );
  };

  onPointClick = (data) => {
    const { payload } = data || {};
    const {
      clusterId,
      clusterMeanScore = 0.0,
      customerRiskScore = 0,
      date,
      modelId
    } = payload || {};

    const formattedCluster = {
      ...payload,
      customerRiskScore: parseFloat(customerRiskScore).toFixedNoRounding(2),
      clusterMeanScore: `${parseFloat(clusterMeanScore).toFixedNoRounding(2)} %`
    };
    this.setState(
      {
        latestCluster: formattedCluster,
        point1: { x: date, y: clusterMeanScore },
        point2: { x: date, y: customerRiskScore },
        activeTabKey: `1`,
        clusterIndicatorGroup: DEFAULT_ACTIVE_TAB,
        currentPage: DEFAULT_CURRENT_PAGE,
        currentPageSize: DEFAULT_PAGE_SIZE
      },
      () => {
        this.props.dispatch(
          getCRSClusterInformationData(
            {
              clusterId,
              limit: DEFAULT_PAGE_SIZE,
              modelId,
              clusterIndicatorGroup: this.state.clusterIndicatorGroup,
              offset: (DEFAULT_CURRENT_PAGE - 1) * DEFAULT_PAGE_SIZE
            },
            GET_DATA
          )
        );
      }
    );
  };

  fetchCTAData = () => {
    const { dateRange } = this.state;
    const { startDate, endDate } = dateRange;
    this.setState({ latestCluster: {} });
    this.props.dispatch(
      getCRSTrendAnalysisData(
        {
          customerKey: this.props.customerKey,
          fromDate: getFormattedDate(startDate, dateTimeFormat),
          toDate: getFormattedDate(endDate, dateTimeFormat)
        },
        GET_DATA
      )
    );
  };

  randomColor = (brightness) => {
    function randomChannel(brightness) {
      var r = 255 - brightness;
      var n = 0 | (Math.random() * r + brightness);
      var s = n.toString(16);
      return s.length == 1 ? '0' + s : s;
    }
    return (
      '#' +
      randomChannel(brightness) +
      randomChannel(brightness) +
      randomChannel(brightness)
    );
  };

  onPaginationChange = (page, pageSize) => {
    this.setState({ currentPage: page, currentPageSize: pageSize });
    this.props.dispatch(
      getCRSClusterInformationData(
        {
          clusterId: this.state.latestCluster.clusterId,
          modelId: this.state.latestCluster.modelId,
          clusterIndicatorGroup: this.state.clusterIndicatorGroup,
          limit: pageSize,
          offset: (page - 1) * pageSize
        },
        GET_DATA
      )
    );
  };

  tabChange = (tab, key) => {
    this.setState({
      activeTabKey: `${key}`,
      clusterIndicatorGroup: tab,
      currentPage: DEFAULT_CURRENT_PAGE,
      currentPageSize: DEFAULT_PAGE_SIZE
    });
    this.props.dispatch(
      getCRSClusterInformationData(
        {
          clusterId: this.state.latestCluster.clusterId,
          modelId: this.state.latestCluster.modelId,
          clusterIndicatorGroup: tab,
          limit: DEFAULT_PAGE_SIZE,
          offset: (DEFAULT_CURRENT_PAGE - 1) * DEFAULT_PAGE_SIZE
        },
        GET_DATA
      )
    );
  };

  render() {
    const { crsRiskDetailData } = this.props;
    const { trendAnalysisData, clusterInformationResponse } =
      processDataFromProps(crsRiskDetailData);

    const { crsFeatureCategoryCodesData = [] } = this.props;
    const {
      data = {},
      fetched: isTAFetched,
      isFetching: isTAFetching
    } = trendAnalysisData || {};

    let ruleBased = true;

    const nonZeroModel = data.customerScores?.filter((obj) => obj.modelId != 0);
    if (nonZeroModel?.length > 0) ruleBased = false;

    const { customerScores = [] } = data || {};
    const processedCustomerScores = [];
    customerScores.forEach((scoreObject) => {
      const { clusterId, customerRiskScore, clusterMeanScore, date, modelId } =
        scoreObject;
      processedCustomerScores.push({
        clusterId,
        modelId,
        date: getFormattedDate(date, dateFormat_DD_MM_YY),
        customerRiskScore: customerRiskScore
          ? getDecimalWithoutHundredMultiplier(customerRiskScore)
          : 0.0,
        rawRoundedCustomerRiskScore: customerRiskScore
          ? parseFloat(customerRiskScore).toFixedNoRounding(2)
          : 0.0,
        clusterMeanScore: clusterMeanScore
          ? parseFloat(clusterMeanScore).toFixedNoRounding(2)
          : 0.0
      });
    });
    const clusterInfo = getDataFromResponse(
      clusterInformationResponse,
      'object'
    );
    const { isFetching } = clusterInformationResponse || {};
    return (
      <>
        <Card header="Trend Analysis and Customer Risk Lineage">
          <div>
            <WidgetActionComponent
              size="small"
              hasDatePicker={true}
              hasDurationPicker={true}
              onChangeActions={this.onDatePickerSelection}
            />
            {isFetching && (
              <div className={style.loaderBar}>
                <Wait4Me />
                <span>Fetching Cluster Data....</span>
              </div>
            )}
            {isTAFetching && !isTAFetched && (
              <div className={style.loaderBar}>
                <Wait4Me />
                <span>Fetching Graph Data...</span>
              </div>
            )}
            {isTAFetched && processedCustomerScores.length === 0 && (
              <div className={style.loaderBar}>
                <span>No data to display.</span>
              </div>
            )}

            <div style={{ padding: 5, marginTop: 20 }}>
              <ComposedChart
                width={1270}
                height={500}
                data={processedCustomerScores}
                margin={{
                  top: 20,
                  right: 50,
                  left: 20,
                  bottom: 50
                }}>
                <CartesianGrid strokeDasharray="3 3" />

                <ReferenceLine
                  stokeWidth="0.5"
                  y={HIGH}
                  label={{
                    position: 'right',
                    value: 'High',
                    fill: RED,
                    fontSize: 12
                  }}
                  stroke={RED}
                />
                <ReferenceLine
                  stokeWidth="0.5"
                  y={MID}
                  label={{
                    position: 'right',
                    value: 'Mid',
                    fill: ORANGE,
                    fontSize: 12
                  }}
                  stroke={ORANGE}
                />

                <ReferenceLine
                  stokeWidth="0.5"
                  y={NONE}
                  label={{
                    position: 'right',
                    value: 'X',
                    fill: BLACK,
                    fontSize: 12
                  }}
                  stroke={BLACK}
                />

                <ReferenceLine
                  stokeWidth="0.5"
                  y={LOW}
                  label={{
                    position: 'right',
                    value: 'Low',
                    fill: GREEN,
                    fontSize: 12
                  }}
                  stroke={GREEN}
                />

                <XAxis dataKey="date" textAnchor="middle">
                  <Label
                    offset={-10}
                    value={'Date'}
                    position="insideBottom"
                    style={{
                      textAnchor: 'middle',
                      fill: '#6A7088',
                      font: '500 14px Inter'
                    }}
                  />
                </XAxis>

                <YAxis
                  tickSize={10}
                  interval={0}
                  type="number"
                  domain={[0, 'auto']}
                  ticks={[0, 20, 40, 60, 80, 100]}>
                  <Label
                    offset={-4}
                    angle={-90}
                    value={'Score'}
                    position="insideLeft"
                    style={{
                      textAnchor: 'middle',
                      fill: '#6A7088',
                      font: '500 14px Inter'
                    }}
                  />

                  <Label
                    offset={20}
                    value={'Y'}
                    position="top"
                    style={{
                      textAnchor: 'middle',
                      fill: '#000'
                    }}
                  />
                </YAxis>
                <Legend
                  layout="horizontal"
                  iconType={'circle'}
                  wrapperStyle={{ left: 0, padding: 0, top: 0 }}
                  margin={{ top: 10, left: 0, right: 10, bottom: 30 }}
                  verticalAlign="top"
                  align="left"
                  height={36}
                  content={(args) => renderLegend(args, ruleBased)}
                />

                <Line
                  type="monotone"
                  dot={false}
                  connectNulls={true}
                  name={'Customer Risk Score'}
                  activeDot={{
                    stroke: '#2B73E0',
                    strokeWidth: 5,
                    // onClick: () => {}
                    onClick: this.onPointClick
                  }}
                  dataKey="customerRiskScore"
                  strokeWidth={'3'}
                  stroke="#2B73E0"
                  isAnimationActive={true}
                  fill="#2B73E0"
                />
                <Tooltip content={(args) => renderTooltip(args, ruleBased)} />
                {!ruleBased && (
                  <Line
                    type="monotone"
                    dot={false}
                    activeDot={{
                      stroke: '#bec3cb',
                      strokeWidth: 5,
                      // onClick: () => {}
                      onClick: this.onPointClick
                    }}
                    isAnimationActive={true}
                    connectNulls={true}
                    name={'Cluster Mean Risk Score'}
                    dataKey="clusterMeanScore"
                    strokeWidth={'3'}
                    stroke="#bec3cb"
                    fill="#bec3cb"
                  />
                )}
                {!ruleBased && (
                  <ReferenceDot
                    x={this.state.point1.x}
                    y={this.state.point1.y}
                    r={8}
                    fill="#bec3cb"
                    stroke="none"
                  />
                )}

                <ReferenceDot
                  x={this.state.point2.x}
                  y={this.state.point2.y}
                  r={8}
                  fill="#2B73E0"
                  stroke="none"
                />
                {/* {processedCustomerScores.map((data, index) => {
                    if (index > 0) {
                      return (
                        <ReferenceDot
                          x={data.date}
                          y={5}
                          r={8}
                          fill={'#bec3cb'}
                          stroke="black"
                        />
                      );
                    }
                  })} */}
              </ComposedChart>
            </div>
            {/* <div>
                <ClusterInformation
                  isLoading={isFetching}
                  latestCluster={this.state.latestCluster}
                  featureCategoryCodesData={crsFeatureCategoryCodesData}
                  clusterInformation={clusterInfo}
                />
              </div> */}
          </div>
        </Card>
        {!ruleBased && (
          <div style={{ marginTop: '20px' }}>
            <ClusterRiskIndicators
              isLoading={isFetching}
              activeTabKey={this.state.activeTabKey}
              latestCluster={this.state.latestCluster}
              clusterInformation={clusterInformationResponse?.data}
              onPaginationChange={this.onPaginationChange}
              defaultPage={DEFAULT_CURRENT_PAGE}
              defaultPageSize={DEFAULT_PAGE_SIZE}
              currentPage={this.state.currentPage}
              tabChange={this.tabChange}
            />
          </div>
        )}
      </>
    );
  }
}

TrendAnalysisComponent.propTypes = {
  dispatch: PropTypes.func,
  customerKey: PropTypes.string,
  crsRiskDetailData: PropTypes.object,
  crsFeatureCategoryCodesData: PropTypes.array
};

/**
 * mapStateToProps
 * @param state
 * @param ownProps
 * @returns {{crsRiskDetailData: crsRiskDetailReducer}}
 */
function mapStateToProps(state, ownProps = {}) {
  return {
    crsRiskDetailData: state.crsRiskDetailReducer
  };
}

/**
 * mapDispatchToProps
 * @param dispatch
 * @param ownProps
 * @returns {{dispatch: *, navigateTo: navigateTo}}
 */
function mapDispatchToProps(dispatch, ownProps = {}) {
  return {
    dispatch
  };
}

/**
 * connect function for CRSRiskDetail page
 */
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TrendAnalysisComponent);
